/**
 * @file functions/isSyliusOrderResponse.ts
 * 
 * Utility function to check if a given data object
 * matches the structure of a Sylius order response.
 */

import type { SyliusOrderResponse } from '@/lib/types/syliusOrderResponse';

export function isSyliusOrderResponse(data: unknown): data is SyliusOrderResponse {
  // Must be a non-null object
  if (typeof data !== 'object' || data === null) return false;

  // TypeScript now knows data is Record<string, unknown>
  const obj = data as Record<string, unknown>;

  return (
    typeof obj.tokenValue === 'string' &&
    Array.isArray(obj.items) &&
    typeof obj.total === 'number'
  );
}
